import type { StrapiBaseRequest } from '@/interfaces/strapi';

export const queryParams: StrapiBaseRequest = {
	populate: {
		exterior: true,
		acceso: true,
		interior1: true,
		interior2: true,
		dossier: true,
	},
} as const;
